import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { sendStoreLogs as apiStoreLogs } from "../../services/apiStoreLogs";

export function useSendStoreLogs() {
    const queryClient = useQueryClient();

    //views,likes,shares,install_the_app,save_the_number,download_the_qr_code
    const {
        mutate: storeLogs,
        isPending,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiStoreLogs({ type: req }),
        onSuccess: (response) => {
            if (response.status === true) {
                // toast.success(response.message);
                queryClient.invalidateQueries({
                    queryKey: ["home"],
                });
            } else {
                toast.error(response.message);
            }
        },
        onError: (err) => {
            console.error("🚀 ~ useCreateStory ~ error response:", err);
        },
    });

    return { storeLogs, isPending, error, results };
}
